import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { UserRole } from '@/types';

export function useUsers() {
  const { users, addUser, updateUserPhone, updateUserPassword, deleteUser } = useAuthStore();
  const [showAddDialog, setShowAddDialog] = useState(false);

  const handleAddUser = (userData: { 
    username: string; 
    phoneNumber: string; 
    role: UserRole;
    password: string;
  }) => {
    addUser(userData);
  };

  const handleUpdatePhone = (userId: string, phoneNumber: string) => {
    updateUserPhone(userId, phoneNumber);
  };

  const handleUpdatePassword = (userId: string, password: string) => {
    updateUserPassword(userId, password);
  };

  const handleDeleteUser = (userId: string) => {
    deleteUser(userId);
  };

  return {
    users,
    showAddDialog,
    setShowAddDialog,
    handleAddUser,
    handleUpdatePhone,
    handleUpdatePassword,
    handleDeleteUser,
  };
}